import React from 'react';
import { useNavigate } from 'react-router-dom';

const UnderConstruction = ({ featureName }) => {
  const navigate = useNavigate();

  return (
    <div className="container vh-100 d-flex justify-content-center align-items-center">
      <div className="col-12 col-md-8 col-lg-6 text-center">
        {/* Mantendo a animação PhantomTech que criamos */}
        <div className="card shadow border-0 p-4 p-md-5 phantom-tech-animate"> 
          <div className="card-body">
            
            {/* Substituindo o ícone pela sua imagem */}
            <div className="mb-4">
              <img 
                src={`${process.env.PUBLIC_URL}/em_construcao.png`} 
                alt="Obras em andamento" 
                className="img-fluid" 
                style={{ maxHeight: '500px', width: 'auto' }}
              />
            </div>
            
            <h2 className="fw-bold text-dark mb-3">
              {featureName || ""} 503 Coming Soon
            </h2>
            
            <p className="text-muted mb-4">
              Estamos trabalhando duro para trazer a melhor experiência para você.
            </p>

            <div className="progress mb-4" style={{ height: '10px' }}>
              <div 
                className="progress-bar progress-bar-striped progress-bar-animated bg-warning" 
                role="progressbar" 
                style={{ width: '75%' }}
              ></div>
            </div>

            <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
              <button 
                type="button" 
                className="btn btn-primary btn-lg px-4"
                onClick={() => navigate('/')}
              >
                
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderConstruction;